import { useEffect, useRef } from 'react';

/**
 *
 * @param {Object} options
 * @param {boolean} options.hasNextPage
 * @param {Function} options.fetchNextPage
 * @param {boolean} options.disabled
 * @returns {React.MutableRefObject<HTMLElement | null>}
 */
const useScrollObserver = ({ hasNextPage, fetchNextPage, disabled }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || disabled) return;

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting && hasNextPage) {
        fetchNextPage();
      }
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [hasNextPage, fetchNextPage, disabled]);

  return ref;
};

export { useScrollObserver };
